import apiRoutes from './api.routes';
import ModelService from './model.service';
import api from './api.service';

const BlogPostCategoriesService = new ModelService(apiRoutes.blogPostCategories, '/blogPostCategories');

BlogPostCategoriesService.destroy = id => api.catchError(async () => {
  const status = await api.destroy(`${apiRoutes.blogPostCategories}/${id}`);
  return status;
});

BlogPostCategoriesService.defaultCover = '/img/blog3.png';
BlogPostCategoriesService.modelName = 'BlogPostCategories';

BlogPostCategoriesService.getCover = (filename, w = false, h = false, c = false) => {
  if (!filename) return BlogPostCategoriesService.defaultCover;
  return BlogPostCategoriesService.getFilePathByDir(`/uploads/${api.subdomain}/blog`, filename, w, h, c);
};

BlogPostCategoriesService.getData = params => api.catchError(async () => {
  const { data, headers: { 'x-total-count': count } } = await api.get(`${apiRoutes.blogPostCategories}`, params);
  return { data, count: parseInt(count, 10) };
});

export default BlogPostCategoriesService;



// WEBPACK FOOTER //
// ./src/services/blogPostCategories.service.js